import { render, staticRenderFns } from "./item2.vue?vue&type=template&id=c1d69de4&scoped=true&"
import script from "./item2.vue?vue&type=script&lang=ts&"
export * from "./item2.vue?vue&type=script&lang=ts&"
import style0 from "./item2.vue?vue&type=style&index=0&id=c1d69de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d69de4",
  null
  
)

export default component.exports